import { render, staticRenderFns } from "./RawMaterialTabView.vue?vue&type=template&id=785635b8&"
import script from "./RawMaterialTabView.vue?vue&type=script&lang=js&"
export * from "./RawMaterialTabView.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterialTabView.vue?vue&type=style&index=0&id=785635b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports